<i18n>
  {
    "en": {
      "averagedinertime": "Average diner time"
    },
    "es": {
      "averagedinertime": "Tiempo medio del comensal"
    }
  }
</i18n>

<script>
import Component from 'vue-class-component';
import { MapActions } from '@core/helpers/decorators';
import KpiComponent from './KpiComponent.vue';
import * as KPITypes from '../constants';

@Component
@MapActions(['calculateAverageDinerTimeKPI'])
export default class AverageDinerTimeKpi extends KpiComponent {
  unit = 'mins'

  unitPosition = 'right'

  isCurrencyUnit = false

  icon = 'fas fa-clock'

  iconSize = 20;

  kpiType = KPITypes.AVERAGE_DINER_TIME

  get title() {
    return this.$t('averagedinertime');
  }

  async calculate() {
    await this.calculateAverageDinerTimeKPI({ pointOfSaleGuid: this.$route.params.pointOfSaleGuid, isManaged: this.isManaged });
    this.loadKPIModel();
  }
}
</script>
